import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=6e716d63&scoped=true&"
import script from "./Chips.vue?vue&type=script&lang=ts&"
export * from "./Chips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e716d63",
  null
  
)

export default component.exports